module.exports = __webpack_public_path__ + "static/media/ID Card back_.441bda98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ID Card back_.png
// module id = 643
// module chunks = 0 1